import { canTrack } from "./can-track";
import type { AnalyticsEventName, AnalyticsEventParamsMap } from "./event-map";
import { sanitizeParams } from "./sanitize-params";

export const trackPageView = (pagePath: string, pageTitle?: string): void => {
	if (!canTrack()) {
		return;
	}

	const params: Record<string, string> = {
		page_path: pagePath,
	};
	if (pageTitle) {
		params.page_title = pageTitle;
	}

	if (typeof window.gtag === "function") {
		window.gtag("event", "page_view", params);
	}
};

export const trackEvent = <K extends AnalyticsEventName>(
	eventName: K,
	params: AnalyticsEventParamsMap[K]
): void => {
	if (!canTrack()) {
		return;
	}

	const sanitized = sanitizeParams(
		params as unknown as Record<string, unknown>
	);

	if (typeof window.gtag === "function") {
		window.gtag("event", eventName, sanitized as Record<string, unknown>);
	}
};

export const analytics = {
	trackPageView,
	trackEvent,
};

export default analytics;
